import { createElement } from 'react';

function bindInlinePlayback(node: HTMLVideoElement | null) {
  if (!node) {
    return;
  }
  node.muted = true;
  node.setAttribute('muted', '');
  node.setAttribute('playsinline', 'true');
  node.setAttribute('webkit-playsinline', 'true');
  void node.play().catch(() => undefined);
}

export function FeaturedEventVideo({ uri }: { uri: string }) {
  return createElement(
    'div',
    {
      'aria-hidden': true,
      style: {
        position: 'absolute',
        inset: 0,
        zIndex: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
      },
    },
    createElement('video', {
      src: uri,
      autoPlay: true,
      muted: true,
      loop: true,
      playsInline: true,
      preload: 'auto',
      controls: false,
      disablePictureInPicture: true,
      ref: bindInlinePlayback,
      style: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center',
        transform: 'translateZ(-1px)',
      },
    }),
  );
}
